export default {
    name: "discover-list",
    data() {
        return {
            isLoading: true,
            search: '',
            perPage: parseInt(this.postsPerPage),
            lastItem: parseInt(this.postsPerPage),
            posts: this.json.posts,
            categories: this.json.cats,
            currentCats: [],
            step: parseInt(this.loadStep),

        }
    },

    props: {
        json: Object,
        postsPerPage: [Number, String],
        loadStep: [Number, String],
        placeholder: [String],
    },

    computed: {
        postsList() {
            let posts = this.posts;

            if (this.currentCats.length) {
                posts = posts.filter(post => {
                    return this.currentCats.every(cat => post.categories.includes(cat));
                    // return post.categories.some(cat => this.currentCats.includes(cat));
                })
            }

            posts = posts.filter(post => {
                return post.title.toLowerCase().includes(this.search.toLowerCase())
            })

            return posts;
        },

        printedPosts() {
            return this.postsList.slice(0, this.lastItem)
        },

        isButtonShowed() {
            return this.lastItem < this.postsList.length;
        }
    },

    methods: {
        loadMore() {
            this.lastItem = this.lastItem + this.step;
        },
        mapCategory(selectedCategory) {
            if (selectedCategory == 'All') {
                this.currentCats = [];
            } else {
                const catIndex = this.currentCats.indexOf(selectedCategory);
                if (catIndex > -1) {
                    this.currentCats = [];
                } else {
                    this.currentCats = [];
                    this.currentCats.push(selectedCategory);
                }
            }

        }
    },
}